<template>
  <div class="sys-page">
    <div class="toolbar">
      <h3>接口权限 (sys_api_resource)</h3>
      <el-button v-perm="'system:api-resource:save'" type="primary" size="small" @click="openEdit(null)">新增接口</el-button>
    </div>
    <p class="hint">
      这里维护网关对代理接口的鉴权规则。gateway.unmatched-policy=deny 时,未登记的接口会被直接拒绝。
      required_perm 留空 = 登录即可访问。
    </p>

    <el-table :data="rows" v-loading="loading" border stripe size="small">
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="upstream" label="上游" width="110" />
      <el-table-column prop="pathPattern" label="路径匹配" />
      <el-table-column prop="method" label="方法" width="90" />
      <el-table-column prop="requiredPerm" label="所需权限" />
      <el-table-column label="状态" width="80">
        <template slot-scope="s">{{ s.row.status === 1 ? "启用" : "禁用" }}</template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="s">
          <el-button v-perm="'system:api-resource:save'" size="mini" @click="openEdit(s.row)">编辑</el-button>
          <el-button v-perm="'system:api-resource:delete'" size="mini" type="danger" plain @click="removeRow(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="editing.id ? '编辑接口' : '新增接口'" :visible.sync="editVisible" width="520px">
      <el-form :model="editing" label-width="100px" size="small">
        <el-form-item label="名称"><el-input v-model="editing.name" /></el-form-item>
        <el-form-item label="上游">
          <el-select v-model="editing.upstream" style="width:100%">
            <el-option v-for="u in upstreams" :key="u" :label="u" :value="u" />
          </el-select>
        </el-form-item>
        <el-form-item label="路径匹配">
          <el-input v-model="editing.pathPattern" placeholder="例如 /api/user/**" />
        </el-form-item>
        <el-form-item label="方法">
          <el-select v-model="editing.method" style="width:100%">
            <el-option v-for="m in methods" :key="m" :label="m" :value="m" />
          </el-select>
        </el-form-item>
        <el-form-item label="所需权限">
          <el-input v-model="editing.requiredPerm" placeholder="留空 = 登录即可" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="editing.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { systemModules } from "@r";

export default {
  data() {
    return {
      loading: false,
      rows: [],
      editVisible: false,
      editing: this.blank(),
      upstreams: ["API", "NODE", "V1", "AMAZON", "RESOURCE", "BIGDATA"],
      methods: ["*", "GET", "POST", "PUT", "DELETE", "PATCH"],
    };
  },
  created() { this.load(); },
  methods: {
    blank() {
      return { id: null, name: "", upstream: "API", pathPattern: "", method: "*", requiredPerm: "", status: 1 };
    },
    load() {
      this.loading = true;
      systemModules.listApiResources()
        .then(res => { this.rows = res.data || []; })
        .catch(e => this.$message.error(e.message || "加载失败"))
        .finally(() => { this.loading = false; });
    },
    openEdit(row) {
      this.editing = row ? { ...row } : this.blank();
      this.editVisible = true;
    },
    save() {
      systemModules.saveApiResource(this.editing)
        .then(() => { this.$message.success("保存成功"); this.editVisible = false; this.load(); })
        .catch(e => this.$message.error(e.message || "保存失败"));
    },
    removeRow(row) {
      this.$confirm(`确认删除 ${row.name} ?`, "提示", { type: "warning" })
        .then(() => systemModules.deleteApiResource(row.id))
        .then(() => { this.$message.success("已删除"); this.load(); })
        .catch(e => e !== "cancel" && this.$message.error((e && e.message) || "删除失败"));
    },
  },
};
</script>

<style scoped>
.sys-page { padding: 16px; background: #fff; min-height: 100%; }
.toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.toolbar h3 { margin: 0; }
.hint { color: #909399; font-size: 12px; margin: 0 0 12px 0; }
</style>
